import clsx from 'clsx';
import styles from './KycReasonNotice.module.css';

interface KycReasonNoticeProps {
  // RNB-195: the resolved, user-facing KYC reason (see utils/kycFailure.getKycFailureText).
  // Renders nothing when empty, so callers can pass it through unconditionally.
  text?: string | null;
  // Dashboard surfaces are left-aligned; modals/popups center their content.
  align?: 'left' | 'center';
  className?: string;
}

// RNB-195: single source of truth for *how* the KYC failure reason looks, so it renders the same
// way wherever we explain why verification needs attention — the profile/dashboard status, the
// re-verify modal, and the verification result popups.
export const KycReasonNotice = ({ text, align = 'left', className }: KycReasonNoticeProps) => {
  if (!text) {
    return null;
  }

  return <p className={clsx(styles.notice, align === 'center' && styles.center, className)}>{text}</p>;
};
